/**
 * Created by hehuizhong on 2017/5/22.
 */
function getError (action, option, xhr, method) {
  const msg = `fail to ${method} ${action} ${xhr.status}'`
  const err = new Error(msg)
  err.status = xhr.status
  err.method = method
  err.url = action
  return err
}

function getBody (xhr) {
  const text = xhr.responseText || xhr.response
  if (!text) {
    return text
  }

  try {
    return JSON.parse(text)
  } catch (e) {
    return text
  }
}

export default function upload (option) {
  if (typeof XMLHttpRequest === 'undefined') {
    return
  }

  const xhr = new XMLHttpRequest()
  const action = option.action
  const method = option.method

  if (xhr.upload) {
    xhr.upload.onprogress = function progress (e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100
      }
      option.onProgress(e)
    }
  }

  const formData = new FormData()

  if (option.data) {
    Object.keys(option.data).map(key => {
      formData.append(key, option.data[ key ])
    })
  }

  formData.append(option.filename, option.file)

  xhr.addEventListener('error', function error (e) {
    option.onError(getError(action, option, xhr, method))
  })

  xhr.addEventListener('load', function onload () {
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(action, option, xhr, method), getBody(xhr))
    }

    option.onSuccess(getBody(xhr))
  })

  xhr.open(method, action, true)

  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true
  }

  const headers = option.headers || {}

  // if (headers['X-Requested-With'] !== null) {
  //   xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  // }

  for (let item in headers) {
    if (headers.hasOwnProperty(item) && headers[ item ] !== null) {
      xhr.setRequestHeader(item, headers[ item ])
    }
  }
  xhr.send(formData)
}



// WEBPACK FOOTER //
// ./src/components/upload/ajax.js